import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'hostedblog/preview/{page}';

export const useHostedBlogPagePreviewQuery = ({
	page,
	impersonationContext,
	enabled,
}: {
	page: Api.CustomPageType;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();

	// Determine which preview endpoint to use based on page type
	// 'main' = home/index page preview, 'individual' = individual post preview
	const previewEndpoint =
		page === Api.CustomPageType.BlogPost || page === Api.CustomPageType.BlogIndividualPage ? 'individual' : 'main';

	return useQuery({
		enabled,
		queryFn: async () => {
			return new Promise<string>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: `hostedblog/preview/${previewEndpoint}`,
						impersonationContext,
					}),
					'GET',
					null,
					async response => {
						resolve(await response.text());
					},
					error => {
						reject(error);
					}
				);
			});
		},
		queryKey: [BASE_QUERY_KEY, page, impersonationContext],
	});
};

export const invalidateHostedBlogPagePreview = (page: Api.CustomPageType) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, page] });
};
